<div class="page-dashboard">
  <div class="row">
    <div class="col">
      <fx-page-header [title]="'Dashboard'"></fx-page-header>
    </div>
  </div>

  <div class="row mb-3" *ngIf="dataSummary && summaryWaiting">
    <div class="col">
      <fx-total-profit
        [class]="'bg-dark-lighter text-white'"
        [uppercase]="true"
        [data]="dataSummary"
        [currency]="currency"
        [caption]="'(Data retrieved last minute)'"
      ></fx-total-profit>
    </div>
  </div>

  <div class="row mb-3" *ngIf="!summaryWaiting">
    <div class="col">
      <p-skeleton height="220px"></p-skeleton>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <fx-time-condition [datepickerFilter]="datepickerFilter" (emitTime)="onTimeframeChange($event)">
      </fx-time-condition>
    </div>
  </div>

  <div class="fs-24 mb-3">Profit</div>
  <div class="row" *ngIf="profitWaiting">
    <div class="col">
      <div class="profit">
        <fx-profit
          [channels]="'EXCHANGES'"
          [currency]="currency"
          [dataProfit]="data"
        >
        </fx-profit>
      </div>
    </div>
    <div class="col-12 col-lg-auto">
      <div class="portfolio">
        <fx-profit-portfolio
          [title]="'Profit'"
          [channels]="'EXCHANGES'"
          [total]="laterData"
          [currency]="currency"
        >
        </fx-profit-portfolio>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!profitWaiting">
    <div class="col">
      <div class="profit">
        <p-skeleton height="600px"></p-skeleton>
      </div>
    </div>
    <div class="col-12 col-lg-auto">
      <div class="portfolio">
        <p-skeleton height="600px"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="walletWaiting">
    <div class="col-12">
      <div class="fs-24  mb-3">Wallet</div>
    </div>
    <div class="col-12 col-lg-9">
      <fx-profit
        [channels]="'WALLETCHANGE'"
        [currency]="currency"
        [dataProfit]="dataWallet"
      >
      </fx-profit>
    </div>
    <div class="col-12 col-lg-3">
      <fx-profit-portfolio
        [title]="'Wallet'"
        [channels]="'WALLETCHANGE'"
        [total]="dataLaterWallet"
        [currency]="currency"
      >
      </fx-profit-portfolio>
    </div>
  </div>
</div>
